// Mechanic registry. pick(exercise) = first mechanic whose matches() is true.
// Order (SC-H3): timer (duration_seconds) → counter (reps) → plain (always). Adding a mechanic = one file + one entry.
import { timer } from './timer.js';
import { counter } from './counter.js';
import { plain } from './plain.js';

export const MECHANICS = [timer, counter, plain];

export function pickMechanic(exercise) {
  return MECHANICS.find(m => m.matches(exercise)) || plain;
}
